module.exports = require("react-dev-utils/clearConsole");